export function jsonify(value: any) {
  return JSON.stringify(value, null, 2);
}
